import { css } from 'styled-components'

export const active = css`
  font-weight: 600;
  color: ${(p) => p.theme.color.blue300};
`

export const hidden = css`
  display: none;
`

export const boxShadow = css`
  margin-bottom: 1px;
  box-shadow: 0 1px 0 0 ${(p) => p.theme.color.grey80};
`

export const inputSearchCancelButtonStyle = css`
  input[type='search']::-webkit-search-cancel-button {
    appearance: none;
    position: relative;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: url('/static/images/ic-close.svg') no-repeat center;
    background-size: 16px 16px;
  }
`
